import React from "react";
import { ProjectCheckBoxLabel, ProjectListInfoContainer } from "../common/styled/project";
import { MdMenu } from "react-icons/md";
import { LuLayoutGrid } from "react-icons/lu";
import { useMediaQuery } from "react-responsive";

const Info = ({
  isDoneProjects,
  handleDoneProject,
  searched,
  setSearched,
  setShowSideMenu,
  showSideMenu,
  clickSideMenu,
  setClickSideMenu,
  handleSearch,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });

  return (
    <ProjectListInfoContainer>
      <div className="projectListHeader">
        <div className="info">
          내 프로젝트
          <ProjectCheckBoxLabel>
            <span>완료된 프로젝트 포함</span>
            <input type="checkbox" checked={isDoneProjects} onChange={handleDoneProject} />
          </ProjectCheckBoxLabel>
        </div>
        <div className="search">
          <input
            type="text"
            placeholder="프로젝트명을 입력해주세요."
            value={searched}
            onChange={(e) => setSearched(e.target.value)}
            onKeyDown={(e) => handleEnterKey(e, handleSearch)}
          />
          <button>검색</button>
        </div>
      </div>
      <div className="sideMenuButtons">
        {isTablet && (
          <button className="sideMenuButton" onClick={() => setShowSideMenu(!showSideMenu)}>
            <MdMenu />
          </button>
        )}
        {isMobile && (
          <button className="sideMenuButton" onClick={() => setClickSideMenu(!clickSideMenu)}>
            <LuLayoutGrid />
          </button>
        )}
      </div>
    </ProjectListInfoContainer>
  );
};

export default Info;
